import SortingVisualizer from "./sortingVisualizer/SortingVisualizer";

function App() {
  return (
    <div className="App">
      <SortingVisualizer />
    </div>
  );
}

export default App;
